import { useCallback, useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "hooks"
import organizationService from "services/organizationService"
import { setOrganizations } from "slices/organizationSlice"

export function useOrganizations() {
  const dispatch = useAppDispatch()
  const organizations = useAppSelector((state) => state.organization.organizations)
  const [error, setError] = useState<string | null>(null)
  const [loaded, setLoaded] = useState(false)

  const refetch = useCallback(() => {
    setError(null)
    organizationService
      .getOrganizations()
      .then((orgs) => {
        dispatch(setOrganizations(orgs))
      })
      .catch(() => {
        setError("Failed to load organizations. Organisation filter unavailable.")
      })
  }, [dispatch])

  useEffect(() => {
    if (!loaded) {
      refetch()
      setLoaded(true)
    }
  }, [loaded, refetch])

  return { organizations, error, refetch }
}
